import { defineComponent as o, openBlock as r, createBlock as a, unref as l, mergeProps as p, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconTextInSquareFilled",
  __name: "IconTextInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (u, e) => (r(), a(l(d), p(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12M8 14.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H8m0-3.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8m0-3.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
